import { defineComponent as _defineComponent } from 'vue';
import { ref } from 'vue';
import { route } from 'ziggy-js';
import InvoiceOrders from '../shared/InvoiceOrders.vue';
import InvoiceStatus from "../shared/InvoiceStatus.vue";
import { useUserStore } from '../../../user/stores/useUserStore';
import { Clock, AlertCircle, AlertTriangle, ShieldAlert, Siren, AlertOctagon, ChevronDown, ChevronUp, Package, Building2, X, Tag, Folder, } from 'lucide-vue-next';
import { formatCurrency, formatShortDate } from "@js/utilities/formatters";
import OrderToggleButton from "@js/vue/domain/invoice/components/shared/OrderToggleButton.vue";
import { getInvoiceOrderTags } from "@js/vue/domain/invoice/utils/invoice-grouping";
import LoadingSpinner from "@js/vue/components/ui/LoadingSpinner.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'InvoiceTable',
    props: {
        invoices: { type: Array, required: true },
        loading: { type: Boolean, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const userStore = useUserStore();
        // Track expanded rows using a reactive Set for O(1) lookups
        const expandedRows = ref(new Set());
        const toggleShowOrders = (qbiID) => {
            if (expandedRows.value.has(qbiID)) {
                expandedRows.value.delete(qbiID);
            }
            else {
                expandedRows.value.add(qbiID);
            }
        };
        // Helper function to resolve the icon component and color class for Aging
        const getAgingIconConfig = (days) => {
            if (days >= 365)
                return { icon: AlertOctagon, class: 'aging-critical-365' };
            if (days >= 120)
                return { icon: Siren, class: 'aging-severe-120' };
            if (days >= 90)
                return { icon: ShieldAlert, class: 'aging-high-90' };
            if (days >= 60)
                return { icon: AlertTriangle, class: 'aging-mid-60' };
            if (days >= 30)
                return { icon: AlertCircle, class: 'aging-low-30' };
            return { icon: Clock, class: 'aging-fresh' };
        };
        const __returned__ = { props, userStore, expandedRows, toggleShowOrders, getAgingIconConfig, get route() { return route; }, InvoiceOrders, InvoiceStatus, get ChevronDown() { return ChevronDown; }, get ChevronUp() { return ChevronUp; }, get Package() { return Package; }, get Building2() { return Building2; }, get X() { return X; }, get Tag() { return Tag; }, get Folder() { return Folder; }, get formatCurrency() { return formatCurrency; }, get formatShortDate() { return formatShortDate; }, OrderToggleButton, get getInvoiceOrderTags() { return getInvoiceOrderTags; }, LoadingSpinner };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
